import axios from "axios";
import dayjs from "dayjs";

const BASE_URL = process.env.REACT_APP_SERVER;

const endpoints = {
  default: "/api/v1/events",
  create: "/create",
  update: "/update",
  getAllEvents: "/organizer",
  eventTickets: "/orgUserEventTickets",
};

export async function createEvent(eventData, apiKey) {
  const requestUrl = BASE_URL + endpoints.default + endpoints.create;

  try {
    if (eventData["start_date"]) {
      eventData["start_date"] = Math.floor(
        new Date(eventData["start_date"]).getTime() / 1000
      );
    }
    if (eventData["end_date"]) {
      eventData["end_date"] = Math.floor(
        new Date(eventData["end_date"]) / 1000
      );
    }
    if (eventData["sale_start"]) {
      eventData["sale_start"] = Math.floor(
        new Date(eventData["sale_start"]) / 1000
      );
    }
    if (eventData["sale_end"]) {
      eventData["sale_end"] = Math.floor(
        new Date(eventData["sale_end"]) / 1000
      );
    }
    if (eventData["checkin_start"]) {
      eventData["checkin_start"] = Math.floor(
        new Date(eventData["checkin_start"]) / 1000
      );
    }
    if (eventData["checkin_end"]) {
      eventData["checkin_end"] = Math.floor(
        new Date(eventData["checkin_end"]) / 1000
      );
    }

    const config = {
      method: "post",
      url: requestUrl,
      headers: {
        "x-api-key": apiKey,
      },
      data: eventData,
    };

    const response = await axios(config);

    return response;
  } catch (err) {
    console.log(err);
    return { error: err.response.data };
  }
}

export async function getEvents(id, apiKey) {
  const requestUrl = BASE_URL + endpoints.default + endpoints.getAllEvents;

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
    data: id,
  };

  const response = await axios(config);

  return response;
}

export async function getEventById(eventID, apiKey) {
  const requestUrl =
    BASE_URL +
    endpoints.default +
    "?events=" +
    eventID +
    "&visibility=internal";

  var config = {
    method: "get",
    url: requestUrl,
    headers: {
      "x-api-key": apiKey,
    },
  };

  try {
    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}

export async function updateEvent(updates, event) {
  const requestUrl = BASE_URL + endpoints.default + endpoints.update;
  updates["organization_id"] = event.organization_id;
  updates["event_id"] = event._id;

  if (updates["start_date"]) {
    updates["start_date"] = dayjs(updates["start_date"]).toISOString();
  }
  if (updates["end_date"]) {
    updates["end_date"] = dayjs(updates["end_date"]).toISOString();
  }

  try {
    const config = {
      method: "patch",
      url: requestUrl,
      headers: {
        "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
      },
      data: updates,
    };

    const response = await axios(config);

    return response;
  } catch (err) {
    return { error: err.response.data };
  }
}

export async function updateTicketCategories(updates, event_id) {
  const requestUrl = BASE_URL + endpoints.default + endpoints.update;

  let ticket_discounts = {};
  updates.forEach((item) => {
    ticket_discounts[item.code] = item;
  });

  return axios({
    method: "patch",
    url: requestUrl,
    headers: {
      "x-api-key": process.env.REACT_APP_OOVAL_API_KEY,
    },
    data: { ticket_discounts, event_id },
  });
}
